var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _vm.SaleSettings
                        ? _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("common"))),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        {
                                          attrs: { lg: "7", xl: "6", xs: "12" },
                                        },
                                        [
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title: _vm.$ct(
                                                  "titles.new-sale-default"
                                                ),
                                              },
                                            },
                                            [
                                              _c("app-select-vat", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "new-product-default-vat"
                                                  ),
                                                  fancy: "",
                                                  "use-id": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .DefaultNewProductVatID,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "DefaultNewProductVatID",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.DefaultNewProductVatID",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "mts" },
                                                [
                                                  _c("app-select-vat", {
                                                    attrs: {
                                                      label: _vm.$ct(
                                                        "new-sale-default-vat"
                                                      ),
                                                      fancy: "",
                                                      "use-id": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.SaleSettings
                                                          .DefaultNewSaleVatID,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.SaleSettings,
                                                          "DefaultNewSaleVatID",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "SaleSettings.DefaultNewSaleVatID",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mts" },
                                                [
                                                  _c("app-select-vat", {
                                                    attrs: {
                                                      label: _vm.$ct(
                                                        "new-purchase-default-vat"
                                                      ),
                                                      fancy: "",
                                                      "use-id": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.purchaseSettings
                                                          .DefaultVatID,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.purchaseSettings,
                                                          "DefaultVatID",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "purchaseSettings.DefaultVatID",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("w-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  items:
                                                    _vm.newSaleAutoFocusItems,
                                                  label: _vm.$ct(
                                                    "new-sale-auto-focus-label"
                                                  ),
                                                  fancy: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .NewSaleAutoFocusField,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "NewSaleAutoFocusField",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.NewSaleAutoFocusField",
                                                },
                                              }),
                                              _c("w-input-number", {
                                                staticClass: "mts",
                                                attrs: {
                                                  decimals: 0,
                                                  label: _vm.$ct(
                                                    "default-quotation-days-label"
                                                  ),
                                                  fancy: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .DefaultQuotationValidDays,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "DefaultQuotationValidDays",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.DefaultQuotationValidDays",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$ct("titles.show-fields"),
                                              },
                                            },
                                            [
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct("show-units"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings.ShowUnits,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "ShowUnits",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.ShowUnits",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct("show-leeggoed"),
                                                  disabled:
                                                    !_vm.hasLeeggoedModule,
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .ShowLeeggoed,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "ShowLeeggoed",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.ShowLeeggoed",
                                                },
                                              }),
                                              _c("w-divider"),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct("use-qty-2"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .UseQty2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "UseQty2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.UseQty2",
                                                },
                                              }),
                                              _vm.dossierSaleSettings.UseQty2
                                                ? _c("w-checkbox", {
                                                    attrs: {
                                                      label: _vm.$ct(
                                                        "use-amount-2-as-multiplier"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dossierSaleSettings
                                                          .UseAmount2AsMultiplier,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dossierSaleSettings,
                                                          "UseAmount2AsMultiplier",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dossierSaleSettings.UseAmount2AsMultiplier",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.dossierSaleSettings.UseQty2
                                                ? _c("w-input", {
                                                    attrs: {
                                                      label:
                                                        _vm.$ct("qty-2-label"),
                                                      fancy: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dossierSaleSettings
                                                          .Qty2Label,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dossierSaleSettings,
                                                          "Qty2Label",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dossierSaleSettings.Qty2Label",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("w-divider"),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "purchase-ask-for-bank-transfer"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .PurchaseAskForBankTransfer,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "PurchaseAskForBankTransfer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.PurchaseAskForBankTransfer",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$ct("titles.caching"),
                                              },
                                            },
                                            [
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct("pdf-caching"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .PdfCaching,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "PdfCaching",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.PdfCaching",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "pdf-caching-by-action"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .PdfCachingByAction,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "PdfCachingByAction",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.PdfCachingByAction",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title: _vm.$ct(
                                                  "disabled-sale-edit-fields"
                                                ),
                                              },
                                            },
                                            [
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "disabled-sale-edit-fields-disabled"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .SaleEditDisabledFieldsDisable,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "SaleEditDisabledFieldsDisable",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.SaleEditDisabledFieldsDisable",
                                                },
                                              }),
                                              _c("w-multi-select", {
                                                attrs: {
                                                  fancy: "",
                                                  items:
                                                    _vm.disabledSaleEditFields,
                                                  label: _vm.$ct(
                                                    "disabled-sale-edit-fields"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .SaleEditDisabledFields,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "SaleEditDisabledFields",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.SaleEditDisabledFields",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$ct("template-settings"),
                                              },
                                            },
                                            [
                                              _c("w-input-number", {
                                                attrs: {
                                                  decimals: 0,
                                                  fancy: "",
                                                  label: _vm.$ct(
                                                    "template-settings-days"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .TemplateSettingsDays,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "TemplateSettingsDays",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.TemplateSettingsDays",
                                                },
                                              }),
                                              _c("app-sale-type-multi-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  "use-id": "",
                                                  fancy: "",
                                                  "use-purchase-and-sale": "",
                                                  label: _vm.$ct(
                                                    "template-settings-sale-types"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .TemplateSettingsSaleTypes,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "TemplateSettingsSaleTypes",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.TemplateSettingsSaleTypes",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "template-settings-actual-prices"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .TemplateSettingsUpdatePrices,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "TemplateSettingsUpdatePrices",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.TemplateSettingsUpdatePrices",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        {
                                          attrs: { lg: "5", xl: "6", xs: "12" },
                                        },
                                        [
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title: _vm.$ct(
                                                  "titles.usage-settings"
                                                ),
                                              },
                                            },
                                            [
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct(
                                                      "description-editor"
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .DescriptionEditor,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "DescriptionEditor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.DescriptionEditor",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "select-next-line-on-product-submit"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .SelectNextLineOnProductSubmit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "SelectNextLineOnProductSubmit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.SelectNextLineOnProductSubmit",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "skip-submit-on-description-change"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .SkipSubmitOnDescriptionChange,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "SkipSubmitOnDescriptionChange",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.SkipSubmitOnDescriptionChange",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "wait-for-enter-on-product-search"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .WaitForEnterOnProductSearch,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "WaitForEnterOnProductSearch",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.WaitForEnterOnProductSearch",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mls",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "select-exact-match-on-product-search"
                                                  ),
                                                  disabled:
                                                    !_vm.SaleSettings
                                                      .WaitForEnterOnProductSearch,
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .SelectExactMatchOnProductSearch,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "SelectExactMatchOnProductSearch",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.SelectExactMatchOnProductSearch",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "wait-for-enter-on-contact-search"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .WaitForEnterOnContactSearch,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "WaitForEnterOnContactSearch",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.WaitForEnterOnContactSearch",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct("add-not-to-print"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .AddNotToPrintToTotal,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "AddNotToPrintToTotal",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.AddNotToPrintToTotal",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct(
                                                      "show-sale-recovery"
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .ShowSaleRecovery,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "ShowSaleRecovery",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.ShowSaleRecovery",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "redirect-to-dashboard-after-save"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .RedirectToDashboardAfterSave,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "RedirectToDashboardAfterSave",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.RedirectToDashboardAfterSave",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "clear-selection-after-save"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .ClearSelectionAfterSave,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "ClearSelectionAfterSave",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.ClearSelectionAfterSave",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct(
                                                      "full-sale-row-view"
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .FullSaleRowView,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "FullSaleRowView",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.FullSaleRowView",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "gross-total-is-per-unit"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .GrossTotalIsPerUnit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "GrossTotalIsPerUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.GrossTotalIsPerUnit",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label:
                                                    _vm.$ct(
                                                      "optimized-printing"
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .OptimizedPrinting,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "OptimizedPrinting",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.OptimizedPrinting",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "open-product-create-modal-if-scanned-product-not-found"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .OpenCreateProductModalOnScanAndProductNotFound,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "OpenCreateProductModalOnScanAndProductNotFound",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.OpenCreateProductModalOnScanAndProductNotFound",
                                                },
                                              }),
                                              _c("w-radio", {
                                                attrs: {
                                                  checked:
                                                    !_vm.SaleSettings
                                                      .OpenSearchBrowseOnScannerInput,
                                                  name: _vm.openSearchBrowseOnScannerInputRadioName,
                                                  label: _vm.$ct(
                                                    "automatically-add-product-to-sale-on-scanner-input"
                                                  ),
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.SaleSettings.OpenSearchBrowseOnScannerInput = false
                                                  },
                                                },
                                              }),
                                              _c("w-radio", {
                                                attrs: {
                                                  checked:
                                                    _vm.SaleSettings
                                                      .OpenSearchBrowseOnScannerInput,
                                                  name: _vm.openSearchBrowseOnScannerInputRadioName,
                                                  label: _vm.$ct(
                                                    "open-product-search-browse-on-scanner"
                                                  ),
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.SaleSettings.OpenSearchBrowseOnScannerInput = true
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-settings-group",
                                            {
                                              attrs: {
                                                title: _vm.$ct(
                                                  "titles.other-settings"
                                                ),
                                              },
                                            },
                                            [
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "delete-imported-sale"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .AutomaticallyDeleteImportedSales,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "AutomaticallyDeleteImportedSales",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.AutomaticallyDeleteImportedSales",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "add-empty-line-after-import"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .AddEmptyLineAfterImport,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "AddEmptyLineAfterImport",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.AddEmptyLineAfterImport",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "import-sale-at-selected-row"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .ImportSaleAtSelectedRow,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "ImportSaleAtSelectedRow",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.ImportSaleAtSelectedRow",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "match-vat-breakdown-to-total"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .MatchVatBreakdownToTotal,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "MatchVatBreakdownToTotal",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.MatchVatBreakdownToTotal",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  disabled: !_vm.hasUblModule,
                                                  label: _vm.$ct(
                                                    "send-ubl-with-invoice"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.pluginSettings.UBL
                                                      .SendUBLInvoice,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.pluginSettings.UBL,
                                                      "SendUBLInvoice",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "pluginSettings.UBL.SendUBLInvoice",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "allow-edit-signed-documents"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .AllowEditOfSignedDocuments,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "AllowEditOfSignedDocuments",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.AllowEditOfSignedDocuments",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "add-up-price-rule-discount"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .AddUpPriceRulesDiscount,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "AddUpPriceRulesDiscount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.AddUpPriceRulesDiscount",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "require-approval-before-processing"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.purchaseSettings
                                                      .RequireApprovalBeforeProcessing,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.purchaseSettings,
                                                      "RequireApprovalBeforeProcessing",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "purchaseSettings.RequireApprovalBeforeProcessing",
                                                },
                                              }),
                                              _c("w-checkbox", {
                                                staticClass: "mts mb",
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "allow-negative-backorder"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .AllowNegativeBackorders,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "AllowNegativeBackorders",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.AllowNegativeBackorders",
                                                },
                                              }),
                                              _c("w-input-number", {
                                                staticClass: "mts",
                                                attrs: {
                                                  decimals: 0,
                                                  min: 0,
                                                  fancy: "",
                                                  label: _vm.$ct(
                                                    "default-qty-on-empty-line"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .DefaultQtyOnEmptyLine,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "DefaultQtyOnEmptyLine",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.DefaultQtyOnEmptyLine",
                                                },
                                              }),
                                              _c("w-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  items: _vm.extraFieldNames,
                                                  label: _vm.$ct(
                                                    "vies-check-extra-field"
                                                  ),
                                                  fancy: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .ViesCheckExtraField,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "ViesCheckExtraField",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.ViesCheckExtraField",
                                                },
                                              }),
                                              _c("w-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  fancy: "",
                                                  items:
                                                    _vm.openClientInfoModalItems,
                                                  label: _vm.$ct(
                                                    "open-client-info-modal-after-select"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.SaleSettings
                                                      .OpenClientInfoModalAfterSelect,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.SaleSettings,
                                                      "OpenClientInfoModalAfterSelect",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "SaleSettings.OpenClientInfoModalAfterSelect",
                                                },
                                              }),
                                              _c("app-sale-type-multi-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  "use-id": "",
                                                  fancy: "",
                                                  "contact-group-id": 1,
                                                  label: _vm.$ct(
                                                    "sale-types-for-product-last-sold"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.useForProductLastSoldSaleTypeIds,
                                                  callback: function ($$v) {
                                                    _vm.useForProductLastSoldSaleTypeIds =
                                                      $$v
                                                  },
                                                  expression:
                                                    "useForProductLastSoldSaleTypeIds",
                                                },
                                              }),
                                              _c("app-sale-type-multi-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  "use-id": "",
                                                  fancy: "",
                                                  "contact-group-id": 2,
                                                  label: _vm.$ct(
                                                    "sale-types-for-product-last-ordered"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.useForProductLastOrderedSaleTypeIds,
                                                  callback: function ($$v) {
                                                    _vm.useForProductLastOrderedSaleTypeIds =
                                                      $$v
                                                  },
                                                  expression:
                                                    "useForProductLastOrderedSaleTypeIds",
                                                },
                                              }),
                                              _c("app-stock-location-select", {
                                                staticClass: "mts",
                                                attrs: {
                                                  "include-empty": "",
                                                  label: _vm.$ct(
                                                    "to-show-stock-qty-in-product-search"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.dossierSaleSettings
                                                      .ToShowStockQtyInProductSearch,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dossierSaleSettings,
                                                      "ToShowStockQtyInProductSearch",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dossierSaleSettings.ToShowStockQtyInProductSearch",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "app-edit-default-import-sale-row-description-template",
                        {
                          attrs: {
                            title: _vm.$ct(
                              "convert-to-credit-note-import-description"
                            ),
                          },
                          model: {
                            value:
                              _vm.dossierSaleSettings
                                .ConvertToCreditNoteDescriptionTemplate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dossierSaleSettings,
                                "ConvertToCreditNoteDescriptionTemplate",
                                $$v
                              )
                            },
                            expression:
                              "dossierSaleSettings.ConvertToCreditNoteDescriptionTemplate",
                          },
                        }
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-vat-regime-order", {
                        staticClass: "grow",
                        model: {
                          value: _vm.SaleSettings.VatRegimeDisplayOrder,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.SaleSettings,
                              "VatRegimeDisplayOrder",
                              $$v
                            )
                          },
                          expression: "SaleSettings.VatRegimeDisplayOrder",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-vat-regime-order", {
                        staticClass: "grow",
                        attrs: { purchase: "" },
                        model: {
                          value: _vm.SaleSettings.PurchaseVatRegimeDisplayOrder,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.SaleSettings,
                              "PurchaseVatRegimeDisplayOrder",
                              $$v
                            )
                          },
                          expression:
                            "SaleSettings.PurchaseVatRegimeDisplayOrder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-edit-row-extra-info-fields-settings", {
                        attrs: { settings: _vm.SaleSettings },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-edit-button-visibility", {
                        attrs: {
                          title: _vm.$ct("sale-edit-quick-buttons"),
                          "default-settings":
                            _vm.defaultSaleEditQuickButtonVisibility,
                        },
                        model: {
                          value: _vm.SaleSettings.SaleEditQuickButtons,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.SaleSettings,
                              "SaleEditQuickButtons",
                              $$v
                            )
                          },
                          expression: "SaleSettings.SaleEditQuickButtons",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-edit-button-visibility", {
                        attrs: {
                          title: _vm.$ct("sale-edit-hamburger-buttons"),
                          "default-settings":
                            _vm.defaultSaleEditHamburgerButtonVisibility,
                        },
                        model: {
                          value: _vm.SaleSettings.SaleEditHamburgerButtons,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.SaleSettings,
                              "SaleEditHamburgerButtons",
                              $$v
                            )
                          },
                          expression: "SaleSettings.SaleEditHamburgerButtons",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isOwner
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("data-sources"))),
                              ]),
                              _vm.hasCrossDossierAccessModule
                                ? _c(
                                    "w-card-content",
                                    [
                                      _c(
                                        "w-row",
                                        [
                                          _c(
                                            "w-col",
                                            {
                                              attrs: {
                                                lg: "5",
                                                xl: "6",
                                                xs: "12",
                                              },
                                            },
                                            [
                                              _c("w-select", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "data-source-contacts"
                                                  ),
                                                  fancy: "",
                                                  items: _vm.dossierItems,
                                                  up: "",
                                                  disabled:
                                                    _vm.dataSourcesDisabled,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataSourcesSettings
                                                      .ContactsDossierID,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataSourcesSettings,
                                                      "ContactsDossierID",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataSourcesSettings.ContactsDossierID",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-row",
                                        [
                                          _c(
                                            "w-col",
                                            {
                                              attrs: {
                                                lg: "5",
                                                xl: "6",
                                                xs: "12",
                                              },
                                            },
                                            [
                                              _c("w-select", {
                                                attrs: {
                                                  label: _vm.$ct(
                                                    "data-source-products"
                                                  ),
                                                  fancy: "",
                                                  up: "",
                                                  items: _vm.dossierItems,
                                                  disabled:
                                                    _vm.dataSourcesDisabled,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataSourcesSettings
                                                      .ProductsDossierID,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataSourcesSettings,
                                                      "ProductsDossierID",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataSourcesSettings.ProductsDossierID",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "w-card-content",
                                    [
                                      _c("app-missing-module", {
                                        attrs: { "module-id": 85 },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }